import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  title?: string;
  imageTextList?: {
    imageUrl?: string;
    imageAlt?: string;
    subtitle?: string;
    title?: string;
    description?: string;
    cta?: {
      label?: string;
      url?: string;
    };
    moreInfo?: {
      label?: string;
      url?: string;
    };
  }[];
}

const propsSchema: PropsSchemaList = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'imageTextList',
    label: 'Image Text List',
    type: types.ARRAY,
    children: [
      {
        key: 'imageUrl',
        label: 'Image URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alternative Text (A brief description of the image to optimize search engine visibility)',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT,
      },
      {
        key: 'cta',
        label: 'CTA',
        type: types.OBJECT,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
        ]
      },
      {
        key: 'moreInfo',
        label: 'More Info Link',
        type: types.OBJECT,
        children: [
          {
            key: 'label',
            label: 'Label',
            type: types.TEXT,
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT,
          },
        ]
      },
    ]
  },
];

const defaultProps: Props = {
  title: 'Available in Labs',
  imageTextList: [
    {
      imageUrl: 'https://genesis-cdn.ff.com/press_room/2023-08/0829PR/--2023-08-29-17.28.09-default.jpg',
      imageAlt: 'Image Alt',
      subtitle: 'PROJECT IDX',
      title: 'Develop quickly, from anywhere',
      description: 'Project IDX is an experimental new AI-enhanced initiative aimed at bringing your entire full-stack, multiplatform app development workflow to the cloud.',
      cta: {
        label: 'Join waitlist',
        url: 'https://www.ff.com',
      }
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/press_room/2023-08/0829PR/--2023-08-29-17.28.09-default.jpg',
      imageAlt: 'Image Alt',
      subtitle: 'MESSAGES',
      title: 'Express yourself with AI-powered Magic Compose',
      description: 'Asking for a second date? Telling a joke? Get help with what to say in just the right vibe before you send.',
      cta: {
        label: 'Join waitlist',
        url: 'https://www.ff.com',
      },
      moreInfo: {
        label: 'Learn more',
        url: 'https://www.ff.com',
      },
    },
  ]
};

export default {
  title: 'Lab Image Text Grid',
  id: 'LabImageTextGrid',
  propsSchema,
  defaultProps,
}
